import {graphql} from 'react-apollo';

import {SaveProjectMutation, SaveProjectMutationConfig} from '../qql-shared/mutations';
import ProjectForm from '../components/ProjectForm';

export default graphql(SaveProjectMutation, SaveProjectMutationConfig)(ProjectForm);



// WEBPACK FOOTER //
// ./src/containers/ProjectNew.js